import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../../Buttons/Button';
import Icon from '../../Icon/Icon';
import SelectionCounter from '../../Selection/SelectionCounter';

import './TablesSelectorHeader.scss';

type Props = {
    onClose: () => void;
    numberOfSelectedItems: number;
};

const TablesSelectorHeader = ({ onClose, numberOfSelectedItems }: Props) => {
    return (
        <div className="tables-selector-header">
            <div className="tables-selector-header-main">
                <h4>
                    <FormattedMessage id="tablesPage.tablesSelection.header" />
                </h4>
                <Button variant="icon" onClick={onClose}>
                    <Icon>close</Icon>
                </Button>
            </div>
            <SelectionCounter
                numberOfSelectedItems={numberOfSelectedItems}
                active={numberOfSelectedItems > 0}
            />
        </div>
    );
};

export default TablesSelectorHeader;
